import { render, staticRenderFns } from "./DataTableExpan.vue?vue&type=template&id=85447ba6&scoped=true"
import script from "./DataTableExpan.vue?vue&type=script&lang=js"
export * from "./DataTableExpan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85447ba6",
  null
  
)

export default component.exports